import { render, staticRenderFns } from "./badmintonScheduleDialog.vue?vue&type=template&id=0aedbd16&"
import script from "./badmintonScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./badmintonScheduleDialog.vue?vue&type=script&lang=js&"
import style0 from "./badmintonScheduleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports